import { Component } from '@angular/core';
import { ActivatedRoute, Params }   from '@angular/router';
import { UserService } from '../_services/user.service';
import 'rxjs/add/operator/switchMap';

import { User } from '../_models/user';

@Component({
  moduleId: module.id,
  templateUrl: 'edit.user.component.html'
})

export class EditUserComponent {
  model: User;
  error: string;
  loading: boolean;
  success: boolean;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService
  ){}

  ngOnInit(): void {
    this.route.params
      .switchMap((params: Params) => this.userService.getUser(+params['id']))
      .subscribe(user => this.model = user);
  }

  editUser(model: User) {
    this.error = null;
    this.loading = true;
    this.success = false;

    this.userService.editUser(model)
      .then(user => {
        this.success = true;
        this.loading = false;
        this.model = user;
      })
      .catch(err => {
        this.error = JSON.parse(err._body).error;
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/users/edit.user.component.ts